module.exports = __webpack_public_path__ + "img/luxury_bottom@2x.6fdc7b0c.png";